import { render, staticRenderFns } from "./CResizable.vue?vue&type=template&id=b96aa1f4&scoped=true"
import script from "./CResizable.vue?vue&type=script&setup=true&lang=js"
export * from "./CResizable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CResizable.vue?vue&type=style&index=0&id=b96aa1f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96aa1f4",
  null
  
)

export default component.exports